import React from 'react'
import UpCycledd from '../components/UpCycled/Upcycledd'
import Footer from '../components/Home/Footer/Footer'
import UpCycledProducts from '../components/Home/Products/UpCycledProducts'

const UpCycled = () => {
  return (
    <div>
      <UpCycledd />
      <UpCycledProducts />
      <Footer />
    </div>
  )
}

export default UpCycled
